<template>
  <div class="BasicEduSuccessCases">
    <div class="cs-baseEduSucc-part1">
      <div class="container">
        <h1>成功案例</h1>
        <h2>北京新英才学校</h2>
        <div class="item">
          <el-row class="itemrow" type="flex">
            <el-col style="margin-right:60px"><div class="imgbox w1"><img src="../assets/img/cs-baseSucc-1.jpg" alt=""></div></el-col>
            <el-col><div class="imgbox w2"><img src="../assets/img/cs-baseSucc-2.jpg" alt=""></div></el-col>
          </el-row>
        </div>
        <p class="conp">北京市新英才学校是一所集精品幼儿园、特色小学、优质初中和多元高中以及招收外籍学生的汉语中心为一体的十五年一贯制国际化学校。新英才学校扎根中国大地，创新课程体系，淳化人才培养，办高质量的中国学校。学校建立以“爱与创造”为核心精神的育人目标体系，致力于为学生提供卓越的与世界同步的教育课程及体验，通过多元文化课程及特色主题课程，让孩子成为有爱心、有社会责任感、有创造能力、有国际视野、有民族自信的新英才。</p>
        <p class="conp">学校占地180多亩，建筑面积11.7万平方米，投资5.5亿余元；拥有全套全新的现代化教育教学生活设施，包括满足不同饮食习惯的学生餐厅、大型室内体育馆及篮球馆、露天足球场、高尔夫球场、网球场、图书馆、全年开放的游泳馆、健身房、钢琴房等。</p>
        <p class="conp">北京市新英才学校的剑桥国际中心和 AP 国际中心从2019年开始使用 Mac 和 iPad 设备作为学生的学习工具，将 Apple Classroom 软件应用于课堂，教师将科学技术应用到教学中，提高了学生的学习兴趣。教师可以随时了解课堂学习效果和参与情况，以便更加有效地设计教学，并实现高品质的学校体验。同时学校IT及教学团队使用 JAMF pro 推送 APP 教学应用软件，并及时管理学生电脑使用情况。</p>
      </div>
    </div>

    <div class="cs-baseEduSucc-part2">
      <div class="container">
        <h2>凯文学校</h2>
        <div class="item2">
          <el-row :gutter="60">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12"><div class="imgbox"><img src="../assets/img/cs-baseSucc-3.jpg" alt=""></div></el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12"><div class="imgbox"><img src="../assets/img/cs-baseSucc-4.jpg" alt=""></div></el-col>
          </el-row>
        </div>
        <p class="conp">
          凯文教育（证券简称，代码：002659）是一家以国际教育为主营业务的A股上市公司，将打造 K-12 国际化学校为核心，立足于一线城市且逐步辐射全国范围的国际教育产业链。北京海淀凯文学校与北京市朝阳区凯文学校，均拥有顶尖的师资力量和完善的教学平台体系，提供1-12年级国际化教育，采用“小班化”教学模式，师资、物资、学费等均体现一流国际学校水准。这个两所学校IT基础设施非常完备的先进机构，从四年级开始使用 Mac 电脑1:1教学，利用 Apple 科技为具有不同学习方式、学习需求的学生，提供创新型的学习和教学。鼓励学生探索、创新和协作。激发每位学生的潜力。创森智云为学校每次需求提供及时的供货和服务，并与学校为IT团队提供及时的技术支持。
        </p>
      </div>
    </div>

    <div class="cs-baseEduSucc-part3">
      <div class="container">
         <h2>北京市鼎石学校</h2>
      
        <div class="item3">
          <el-row :gutter="60">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12"><div class="imgbox"><img src="../assets/img/cs-baseSucc-5.jpg" alt=""></div></el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12"><div class="imgbox"><img src="../assets/img/cs-baseSucc-6.jpg" alt=""></div></el-col>
          </el-row>
        </div>
        <p class="conp">北京市鼎石学校是一所属于中国的学校，采用国际课程，拥有世界情怀。我们致力于融合中国、美国和国际三种教育传统之精粹，为中国、以及世界带来一种前所未有、独具特色的教育理念——世界学校。</p>
        <p class="conp">北京市鼎石学校坐落于北京市顺义区后沙峪，占地140亩，建筑面积10万平方米。其建筑群包括为“教”与“学”带来全新体验的三座教学楼、三座图书馆和一座国际一流的表演艺术中心。艺术设施包括艺术工作室，一个创客空间，音乐排练室。体育设施包含三个篮球场馆、一个25米长泳道的八道泳池、四间壁球室、一间健身房、一个标准足球场、室内外跑道，以及供小学生专用的室外游戏场地。此外，鼎石还建有两栋设施齐备的宿舍楼。</p>
        <p class="conp">北京市鼎石学校的课程为学生们提供各种机会，让他们在主动学习和严谨治学的同时，勇于冒险，擅于提问，深入分析和探索各种观点，尽情地挥洒自己的想象力。鼎石营造的双语教学环境是为了弘扬对知识的热爱，让学生欣赏不同的学科领域，坚持不懈地追求学术上的卓越，并实现个人的发展与成长。鼎石每个学部中的教师都具备丰富的教学经验，运用启发性的教学方法把学生们培养成为拥有出众竞争能力和文化素养的公民，以便他们能够积极、自如地应对这个日新月异的世界。</p>
        <p class="conp" style="margin-bottom:0">学校为学生提供最新的学习工具和教学资源。从小学一年级开始使用 Apple 平板电脑，三年级以上使用 Apple 笔记本电脑，并配有 Apple 一体机机房。学校全部采用 Apple 设备一对一教学，还专门成立了教育科技创新部门。我们和 Apple 公司一起配合学校的IT信息技术部和教育科技创新部门将创造精神和科技领域结合，帮助学生和教育工作者在一个多元化的全球环境中学生、教学、合作和创新。</p>
      </div>
    </div>

    <div class="cs-baseEduSucc-part3">
      <div class="container">
         <h2>探月学校</h2>
      
        <div class="item3">
          <el-row :gutter="60">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12"><div class="imgbox"><img src="../assets/img/tanyue.jpg" height="474" alt=""></div></el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12"><div class="imgbox"><img src="../assets/img/tanyueDesc.jpeg" alt=""></div></el-col>
          </el-row>
        </div>
        <p class="conp">北京市朝阳区探月学校，位于中国北京市朝阳区林萃路2号国家网球中心莲花球馆，是一所集小学、初中、高中教育为一体的国际化学校。探月学校的前身是北京市朝阳区清森学校，于2023年在朝阳区教委的正式批复下更名为探月学校。这一更名不仅代表了学校发展的新阶段，也寓意着学校对探索未知、引领未来的坚定承诺。探月学校秉承“探索、创新、引领”的教育理念，致力于培养内心丰盈的个体和积极行动的公民，通过融合中西方教育精华，为学生提供优质的教育服务。</p>
        <p class="conp">探月学校的课程设置丰富多样，涵盖小学、初中和高中三个学段。学校还特别注重STEAM教育、全球视野课程和未来科技课程，以培养学生的创新能力和国际竞争力。</p>
        <p class="conp" style="margin-bottom:0">学校为教师团队提供苹果硬件设备，并与创森智云通过DaaS（Device as a Service)模式深度合作,创森智云为探月学校提供设备支持、技术服务、设备管控等综合业务。同时创森智云为探月学校学生提供苹果设备BYOD支持，满足学生日常高效学习，为学生申请国际顶尖大学打下坚实基础。</p>
      </div>
    </div>
    <div class="cs-page">
      <router-link to="home" active-class="activeClass">首页</router-link>
      <router-link to="BasicEduIT" active-class="activeClass">上一页</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name:'BasicEduSuccessCases',
  data() {
    return {
    }
  },
  mounted(){
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
.BasicEduSuccessCases{
   border-bottom: 1px solid #D6D6D6;
   h1{
      font-size: 58px;
      font-weight: 600;
      color: #000000;
      line-height: 76px;
      text-align: center;
      padding: 115px 0 76px 0;
   }
   h2{
      font-size: 42px;
      font-weight: 600;
      color: #000000;
      line-height: 38px;
      margin-bottom: 74px;
      text-align: center;
   }
   .conp{
     max-width: 957px;
     margin: 0 auto;
      font-size: 24px;
      font-weight: 400;
      color: #000000;
      line-height: 38px;
      margin-bottom: 50px;
      text-align: justify;
   }
   .item{
     margin-bottom: 75px;
   }
   .imgbox{
      background: #FFFFFF;
      border-radius: 22px;
      overflow: hidden;
      img{
        max-width: 100%;
      }
   }
   .w1{
     width: 460px;
   }
   .w2{
     width: 680px;
   }
   .cs-baseEduSucc-part1{
     padding: 0 0 27px 0;
   }
   .cs-baseEduSucc-part2{
     background: #FFFFFF;
     padding: 91px 0 15px 0;
     .item2{
       padding: 0 0 75px 0;
     }
   }
   .cs-baseEduSucc-part3{
     background: #f5f5f7;
     padding: 85px 0 0px 0;
     .item3{
       padding: 0 0 75px 0;
     }
   }
}

// 适配
@media screen and (max-width: 992px) {
  .BasicEduSuccessCases .item{
    .w1,.w2{
      width: 100%;
    }
    .w1{
      margin-bottom: 60px;
    }
    .w2{
      img{
        width: 100%;
      }
    }
    .itemrow{
      display: grid;
      text-align: center;
    }
  }
  .BasicEduSuccessCases .cs-baseEduSucc-part2 .item2 .imgbox,
  .BasicEduSuccessCases .cs-baseEduSucc-part3 .item3 .imgbox{
    text-align: center;
    &:first-child{
      margin-bottom: 30px;
    }
  }
  .BasicEduSuccessCases .cs-baseEduSucc-part3 .item3 .imgbox{
    img{
      width: 100%;
    }
  }
}
</style>
